import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { formatDocumentTitle } from '@/utils/documentTitle'

interface BreadcrumbItem {
	label: string
	link?: string
}
interface PageBreadcrumbsWithLinksProps {
	subNames?: BreadcrumbItem[]
	title: string
	/** Extra node placed directly after the title (e.g. a status badge) */
	addedChild?: ReactNode
}

const PageBreadcrumbsWithLinks = ({ subNames = [], title, addedChild }: PageBreadcrumbsWithLinksProps) => {
	return (
		<>
			<title>{formatDocumentTitle(title)}</title>
			<div className="page-toolbar">
				<div className="page-toolbar__row">
					<div className="flex min-w-0 items-center gap-3">
						<h4 className="page-toolbar__title">{title}</h4>
						{addedChild}
					</div>
					{subNames.length > 0 && (
						<nav className="page-toolbar__crumbs" aria-label="Breadcrumb">
							{subNames.map((item, idx) => (
								<span key={idx} className="inline-flex items-center gap-1.5">
									{idx > 0 && <i className="ri-arrow-right-s-line page-toolbar__crumb-sep rtl:rotate-180" aria-hidden />}
									{item.link ? (
										<Link to={item.link} className="hover:text-primary transition-colors">
											{item.label}
										</Link>
									) : (
										<span>{item.label}</span>
									)}
								</span>
							))}
						</nav>
					)}
				</div>
			</div>
		</>
	)
}

export default PageBreadcrumbsWithLinks
